<template>
    <section class="gmp-section gmp-mb-l">
        <div class="two-column-tout">
            <div class="h-c-page">

                <div class="h-c-grid">
                    <div class="h-c-grid__col h-c-grid__col-xl--offset-1 h-c-grid__col-l--6
            h-c-grid__col-xl--5  h-c-grid__col--align-middle
            two-column-tout__content">
                        <h3 class="h-c-headline h-c-headline--one">
                            提升食品安全和质量
                        </h3>
                        <div class="h-u-mb-std two-column-tout__description">
                            <p class="">
                                食品安全追溯：小程序记录食材的采购、库存和使用情况，实现食品安全的全流程追溯，一旦发生问题，可以快速定位并解决，保障食品安全。
                                确保产品一致性：通过严格的食材管理和标准化的操作流程，售卖窗口能够确保食品的口味和质量的一致性，提升客户满意度。
                            </p>
                        </div>
                        <a  @click="toEnterprisePage('/enterprise/windowStore/WIN_Special','/enterprise/windowStore/WIN_Special')"   class="h-c-link h-c-link--internal gmp-link">
                            查看详细
                        </a>

                    </div>

                    <div class="h-c-grid__col
          h-c-grid__col-l--6  h-c-grid__col--align-middle">
                        <div class="two-column-tout__image text-center">
                            <picture>
                                <img src="@/assets/img/win_safe.png" alt="" class="gmp-no-grab ">
                            </picture>
                        </div>
                    </div>

                </div>
            </div>


        </div>

    </section>
</template>

<script>
    export default {
        name: "WIN_twoTout",
        methods:{
            toLevelType(data){
                this.$router.push(data)
                this.isShowDrawer = false;
                this.$('body').removeClass('h-is-showing-drawer');

            },

            toEnterprisePage(data, url) {
                this.$router.push(data)
                this.$('body').removeClass('h-is-showing-drawer');
                var lis = this.$('.h-c-header__drawer-nav-li-link');
                for (var i = 0; i < lis.length; i++) {
                    var toWhere = this.$(lis[i]).attr('to-where');
                    console.log("toWhere===" + toWhere);
                    if (toWhere === url) {
                        this.$(lis[i]).addClass('h-is-active');
                    } else {
                        this.$(lis[i]).removeClass('h-is-active')
                    }
                }
            },
        }
    }
</script>

<style lang="less">


</style>
